import { Autocomplete, Button, Checkbox, Stack, TextField, Typography } from "@mui/material";
import DrawerFiltersComponent from "../../../components/drawer-filters";
import { IDepartmentFilters } from "../../../types/department";
import { ChangeEvent } from "react";
import { IBranch } from "../../../types/branch";

type Props = {
    canReset: boolean;
    open: boolean;
    onClose: VoidFunction;
    onOpen: VoidFunction;
    resetFilters: VoidFunction;
    filters: IDepartmentFilters;
    handleFilters: (name: string, value: string | IBranch[] | null) => void;
    getResults: VoidFunction;
    branches: IBranch[];
    loading: boolean;
}

const DepartmentsFilterComponent = ({ canReset, open, onClose, onOpen, resetFilters, filters, handleFilters, getResults, branches, loading }: Props) => {

    return (
        <DrawerFiltersComponent
            canReset={canReset}
            open={open}
            onClose={onClose}
            onOpen={onOpen}
            resetFilters={resetFilters}
            width={340}
        >
            <>
                <Stack>
                    <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
                        Departamento
                    </Typography>
                    <TextField
                        placeholder="Departamento"
                        value={filters.name}
                        onChange={(event: ChangeEvent<HTMLInputElement>) => handleFilters('name', event.target.value)}
                    />
                </Stack>
                <Stack>
                    <Typography variant="subtitle2" sx={{ mb: 1.5 }}>
                        Filiais
                    </Typography>
                    <Autocomplete
                        multiple
                        options={branches}
                        disableCloseOnSelect
                        getOptionLabel={(option) => option.code + ' - ' + option.name}
                        renderOption={(props, option, { selected }) => (
                            <li {...props}>
                                <Checkbox
                                    style={{ marginRight: 8 }}
                                    checked={selected}
                                />
                                {option.code + ' - ' + option.name}
                            </li>
                        )}
                        fullWidth
                        renderInput={(params) => (
                            <TextField {...params} placeholder="Filiais" />
                        )}
                        value={filters.branches ?? undefined}
                        onChange={(event: unknown, newValue: IBranch[]) => handleFilters('branches', newValue)}
                    />
                </Stack>
                <Stack sx={{ mt: 3 }}>
                    <Button
                        variant="contained"     
                        onClick={() => {
                            onClose();
                            getResults();
                        }}
                    >
                        Pesquisar
                    </Button>
                </Stack>
            </>
        </DrawerFiltersComponent>
    )

}

export default DepartmentsFilterComponent;